import textStyle from './bar.data.tooltip.textStyle'

export default {
  name: "tooltip",
  nickname: "提示",
  desc: "本系列每个数据项中特定的 tooltip 设定。",
  type: "object",
  props: {
    position: {
      name: "position",
      nickname: "位置",
      desc:
        '<strong>注意：</strong><code class="codespan">series.data.tooltip</code> 仅在 <a target="__blank" href="https://echarts.apache.org/zh/option.html#tooltip.trigger">tooltip.trigger</a> 为 <code class="codespan">&#39;item&#39;</code> 时有效。<br>',
    },
    formatter: {
      name: "formatter",
      nickname: "文本格式化",
      desc:
        '<strong>注意：</strong><code class="codespan">series.data.tooltip</code> 仅在 <a target="__blank" href="https://echarts.apache.org/zh/option.html#tooltip.trigger">tooltip.trigger</a> 为 <code class="codespan">&#39;item&#39;</code> 时有效。<br>',
    },
    backgroundColor: {
      name: "backgroundColor",
      nickname: "背景色",
      desc:
        '<strong>注意：</strong><code class="codespan">series.data.tooltip</code> 仅在 <a target="__blank" href="https://echarts.apache.org/zh/option.html#tooltip.trigger">tooltip.trigger</a> 为 <code class="codespan">&#39;item&#39;</code> 时有效。<br>',
      value: "rgba(50,50,50,0.7)",
      defaultValue: "rgba(50,50,50,0.7)",
      type: "pureValue",
    },
    borderColor: {
      name: "borderColor",
      nickname: "边框颜色",
      desc:
        '<strong>注意：</strong><code class="codespan">series.data.tooltip</code> 仅在 <a target="__blank" href="https://echarts.apache.org/zh/option.html#tooltip.trigger">tooltip.trigger</a> 为 <code class="codespan">&#39;item&#39;</code> 时有效。<br>',
      value: "#333",
      defaultValue: "#333",
      type: "pureValue",
    },
    borderWidth: {
      name: "borderWidth",
      nickname: "边框宽度",
      desc:
        '<strong>注意：</strong><code class="codespan">series.data.tooltip</code> 仅在 <a target="__blank" href="https://echarts.apache.org/zh/option.html#tooltip.trigger">tooltip.trigger</a> 为 <code class="codespan">&#39;item&#39;</code> 时有效。<br>',
      value: 0,
      defaultValue: 0,
    },
    padding: {
      name: "padding",
      nickname: "内边距",
      desc:
        '<strong>注意：</strong><code class="codespan">series.data.tooltip</code> 仅在 <a target="__blank" href="https://echarts.apache.org/zh/option.html#tooltip.trigger">tooltip.trigger</a> 为 <code class="codespan">&#39;item&#39;</code> 时有效。<br>',
      value: 5,
      defaultValue: 5,
      type: "pureValue",
    },
    textStyle,
    extraCssText: {
      name: "extraCssText",
      nickname: "额外CSS文本",
      desc:
        '<strong>注意：</strong><code class="codespan">series.data.tooltip</code> 仅在 <a target="__blank" href="https://echarts.apache.org/zh/option.html#tooltip.trigger">tooltip.trigger</a> 为 <code class="codespan">&#39;item&#39;</code> 时有效。<br>',
    },
  },
}
